import styled from '@emotion/styled';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { IconButton, Stack } from '@mui/material';
import { SettingsIcon } from 'components/shared/SettingsIcon/SettingsIcon';

import { UserSettingsDropdown } from './UserSettingsDropdown/UserSettingsDropdown';

export const PageTemplateActions = props => {
  return (
    <Actions>
      <LeftIcons direction="row" justifyContent="flex-start">
        <UserSettingsDropdown
          transparent={props.transparent}
          iconProps={props.transparent ? { sx: { color: 'white' } } : {}}
          size="small"
        />
        <IconBtn
          Icon={NotificationsNoneIcon}
          isTransparent={props.transparent}
          label="notifications"
        />
      </LeftIcons>
      <RightIcons direction="row" justifyContent="flex-end">
        <IconBtn
          Icon={MailOutlineIcon}
          isTransparent={props.transparent}
          label="messages"
        />
        {/* <SettingsIcon icon={} label="settings" />*/}
        {props.transparent ? (
          <IconBtn isTransparent Icon={SettingsOutlinedIcon} />
        ) : null}
      </RightIcons>
    </Actions>
  );
};

const IconBtn = ({ Icon, label, isTransparent, ...props }) => {
  if (!isTransparent) {
    return (
      <SettingsIcon icon={<Icon fontSize="small" />} label={label} {...props} />
    );
  } else {
    return (
      <IconButton {...props}>
        <Icon
          sx={{
            color: 'white',
            fontSize: { xs: '27px' },
          }}
        />
      </IconButton>
    );
  }
};

const Actions = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${({ theme }) => ({
    [theme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'space-between',
    },
  })}
`;

const LeftIcons = styled(Stack)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  margin-right: 16px;
  ${({ theme }) => ({
    [theme.breakpoints.down('md')]: {
      'marginRight': 0,
      'gap': '50px',
      'marginLeft': '10%',
      '& .MuiSvgIcon-root': {
        fontSize: '27px !important',
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '4%',
      gap: '32px',
    },
  })}
`;

const RightIcons = styled(Stack)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  ${({ theme }) => ({
    [theme.breakpoints.down('md')]: {
      marginRight: '10%',
      gap: '50px',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: '4%',
      gap: '32px',
    },
  })},
`;
